import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { Picker } from "emoji-mart";
import clsx from "clsx";
import { playSendMessageSound } from "../../utils/soundAlerts";


import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";
import DescriptionIcon from "@material-ui/icons/Description";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import HeadsetIcon from "@material-ui/icons/Headset";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import SignalWifiOffIcon from "@material-ui/icons/SignalWifiOff";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {
  FormControlLabel,
  Hidden,
  ListItemIcon,
  Menu,
  MenuItem,
  Switch,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import SeletorConteudo from "../SeletorConteudo";
import { FlutuantesAcoesContext } from "../../context/Flutuantes/FlutuantesContext";
import { IconeCalculadora } from "../Flutuantes/CalculadoraFlutuante";




const OPCOES_DE_ANEXO = [
  {
    id: "documento",
    rotulo: "Documento",
    accept: "",
    Icone: DescriptionIcon,
    cor: "#7f66ff",
  },
  {
    id: "midia",
    rotulo: "Fotos e vídeos",
    accept: "image/*,video/*",
    Icone: PermMediaIcon,
    cor: "#007bfc",
  },
  {
    id: "audio",
    rotulo: "Áudio",
    accept: "audio/*",
    Icone: HeadsetIcon,
    cor: "#ff2e74",
  },
];

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import OndasDaGravacao from "./OndasDaGravacao";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { EditingMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import { MensagensPendentesContext } from "../../context/MensagensPendentes/MensagensPendentesContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { formatarNomeOuTelefone } from "../../utils/phone";
import { filtroDeEmoji } from "../../utils/emojiSuportado";
import { toast } from "react-toastify";
import { poderDeAdmin } from "../../utils/perfil";














const FORMATOS_DE_AUDIO = [
  { mime: "audio/ogg;codecs=opus", extensao: "ogg" },
  { mime: "audio/webm;codecs=opus", extensao: "webm" },
  { mime: "audio/mp4", extensao: "m4a" },
  { mime: "audio/webm", extensao: "webm" },
];

const formatoSuportado = () => {
  if (typeof window === "undefined" || !window.MediaRecorder) return null;

  for (const f of FORMATOS_DE_AUDIO) {
    try {
      if (MediaRecorder.isTypeSupported(f.mime)) return f;
    } catch (e) {
      /* navegador antigo sem isTypeSupported */
    }
  }




  return { mime: "", extensao: "webm" };
};

const useStyles = makeStyles(theme => ({
  faixaConexaoCaiu: {
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 16px",
    backgroundColor:
      theme.palette.type === "dark" ? "rgba(245,158,11,0.16)" : "#fff7ed",
    borderTop: "2px solid #f59e0b",
    color: theme.palette.type === "dark" ? "#fcd34d" : "#92400e",
    fontSize: "0.8rem",
    lineHeight: 1.4,
  },

  barraSemConexao: {
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(90deg, rgba(220,38,38,0.22) 0%, rgba(220,38,38,0.10) 100%)"
        : "linear-gradient(90deg, #fee2e2 0%, #fff5f5 100%)",
    borderTop: "3px solid #dc2626",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  semConexaoIcone: {
    color: "#dc2626",
    fontSize: 26,
    flexShrink: 0,
  },

  semConexaoTitulo: {
    fontWeight: 800,
    fontSize: "0.9rem",
    color: "#dc2626",
    letterSpacing: "0.02em",
  },

  semConexaoTexto: {
    fontSize: "0.82rem",
    color: theme.palette.type === "dark" ? "#fca5a5" : "#7f1d1d",
    lineHeight: 1.45,
  },

  compacto: {
    position: "static !important",
    width: "100% !important",
  },
  mainWrapper: {
    background: theme.palette.type === "dark" ? "#1b2320" : "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: theme.palette.type === "dark" ? "#1b2320" : "#ffffff",
    width: "100%",
    display: "flex",
    padding: "10px 10px",
    alignItems: "center",
    // ícones (emoji, anexo, microfone, enviar) com hover verde
    "& .MuiIconButton-root": {
      transition: "color .2s ease, background-color .2s ease, transform .2s ease",
      "&:hover": {
        color: "#1E9855",
        backgroundColor: "rgba(30,152,85,0.10)",
        transform: "scale(1.08)",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: "4px",
    },
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#f3f7f4",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#e3ece6"}`,
    display: "flex",
    borderRadius: 16,
    flex: 1,
    position: "relative",
    transition: "border-color .2s ease, box-shadow .2s ease, background-color .2s ease",
    "&:focus-within": {
      borderColor: "#1E9855",
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#ffffff",
      boxShadow: "0 0 0 3px rgba(30,152,85,0.15)",
    },
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.type === "dark" ? "#1b2320" : "#ffffff",
    borderTop: `1px solid ${theme.palette.divider}`,
  },

  previaMidia: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    flex: 1,
    minWidth: 0,
    padding: "4px 8px",
  },
  previaImagem: {
    maxHeight: 180,
    maxWidth: "100%",
    borderRadius: 8,
    objectFit: "contain",
  },
  previaNome: {
    fontSize: "0.9rem",
    wordBreak: "break-all",
  },
  previaLegenda: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 4,
    backgroundColor: theme.palette.type === "dark" ? "#2a2a2a" : "#fff",
    borderRadius: 20,
    padding: "2px 8px",
  },
  campoLegenda: {
    flex: 1,
    minWidth: 0,
    fontSize: "0.95rem",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
    [theme.breakpoints.down("sm")]: {
      bottom: 56,
      left: 0,
      width: "100%",
    },
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  // A lixeira balanca quando o mouse chega nela. O gesto e curto de proposito:
  // e o botao que joga a gravacao fora, e um aviso discreto de que ali nao tem
  // volta vale mais que um X vermelho parado.
  "@keyframes balancarLixeira": {
    "0%, 100%": { transform: "rotate(0deg)" },
    "20%": { transform: "rotate(-14deg)" },
    "45%": { transform: "rotate(11deg)" },
    "70%": { transform: "rotate(-7deg)" },
    "88%": { transform: "rotate(4deg)" },
  },

  botaoDescartar: {
    "&:hover $cancelAudioIcon": {
      color: "#d32f2f",
      animation: "$balancarLixeira 500ms ease-in-out",
    },
  },

  cancelAudioIcon: {
    color: theme.palette.type === "dark" ? "#8696a0" : "#667085",
    transition: "color 160ms ease",
  },

  botaoEnviarAudio: {
    "&:hover $sendAudioIcon": {
      transform: "translateX(2px)",
    },
  },

  sendAudioIcon: {
    color: "#1E9855",
    transition: "transform 160ms ease",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  atalhoTag: {
    fontFamily: "monospace",
    fontWeight: 700,
    padding: "1px 6px",
    borderRadius: 5,
    marginRight: 8,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(30,152,85,0.22)"
        : "rgba(30,152,85,0.12)",
    color: theme.palette.type === "dark" ? "#7ee2a8" : "#14713f",
  },
  escopoTagGlobal: {
    fontSize: "0.65rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    padding: "1px 6px",
    borderRadius: 5,
    marginRight: 8,
    border: "1px solid rgba(30,152,85,0.5)",
    color: theme.palette.type === "dark" ? "#7ee2a8" : "#14713f",
  },
  escopoTagPessoal: {
    fontSize: "0.65rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    padding: "1px 6px",
    borderRadius: 5,
    marginRight: 8,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
  },
  atalhoTexto: {
    color: theme.palette.text.secondary,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: theme.palette.type === "dark" ? "#1e1e1e" : "#ffffff",
    padding: "2px",
    border: "1px solid #CCC",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "32px",
        "&:hover": {
          background: theme.palette.type === "dark" ? "#333333" : "#F1F1F1",
          cursor: "pointer",
        },
      },
    },
  },
}));

const ComunicadoDialog = ({ ticketId, aberto, onClose, container }) => {
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);

  const enviar = async () => {
    const limpo = texto.trim();
    if (!limpo) return;

    setEnviando(true);
    try {
      await api.post(`/messages/${ticketId}/comunicado`, { body: limpo });
      setTexto("");
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={aberto} onClose={onClose} container={container} maxWidth="sm" fullWidth disableEnforceFocus disableAutoFocus>
      <DialogTitle>Novo comunicado</DialogTitle>
      <DialogContent>
        <p style={{ marginTop: 0, color: "#777", fontSize: "0.85rem" }}>
          Fica visível para toda a equipe dentro desta conversa. O cliente
          não recebe e não vê.
        </p>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          placeholder="Escreva o comunicado..."
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={enviando}>
          Cancelar
        </Button>
        <Button
          onClick={enviar}
          color="primary"
          variant="contained"
          disabled={enviando || !texto.trim()}
        >
          {enviando ? "Publicando..." : "Publicar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const MessageInput = ({
  ticketStatus,
  semConexao,
  conexaoNome,
  conexaoStatus,
  ticketId: ticketIdDaProp,
  compacto = false,
  semMenus = false, // (antigo) mantido só por compatibilidade
}) => {
  const classes = useStyles();
  const params = useParams();
  // Na conversa minimizada (janelinha flutuante) o ticket vem por prop,
  // porque a página aberta pode ser outra.
  const ticketId = ticketIdDaProp ? String(ticketIdDaProp) : params.ticketId;
  const { abrirCalculadora } = useContext(FlutuantesAcoesContext) || {};
  // Menus e janelas (+, comunicado) abrem no MESMO documento deste campo.
  // Na janela "sempre no topo" isso é a própria janelinha, não a página.
  const raizRef = useRef(null);

  // Com a barra "Dados do contato" aberta a caixa fica estreita: o texto de
  // ajuda quebrava em 6 linhas e empurrava tudo. Abaixo de 640px a caixa
  // entra no modo curto (dica curta e "Assinar" so com a chave).
  const [caixaEl, setCaixaEl] = useState(null);
  const [estreito, setEstreito] = useState(false);
  useEffect(() => {
    const el = caixaEl;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const obs = new ResizeObserver((itens) => {
      const largura = itens[0]?.contentRect?.width || el.offsetWidth;
      setEstreito(largura < 640);
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, [caixaEl]);
  const portalNaJanela = () => raizRef.current?.ownerDocument?.body || document.body;

  const [comunicadoAberto, setComunicadoAberto] = useState(false);
  const [enviandoSaudacao, setEnviandoSaudacao] = useState(false);

  // "+" > "Saudação": a saudação do atendente deste atendimento vai na hora.
  // Ela não sai mais sozinha ao transferir (o cliente recebia 2-3 quando o
  // atendente era trocado).
  const enviarSaudacao = async () => {
    if (enviandoSaudacao) return;
    setEnviandoSaudacao(true);
    try {
      await api.post(`/tickets/${ticketId}/saudacao`);
      toast.success("Saudação enviada ao cliente.");
    } catch (err) {
      toastError(err);
    } finally {
      setEnviandoSaudacao(false);
    }
  };

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [streamDaGravacao, setStreamDaGravacao] = useState(null);









  const inputArquivoRef = useRef(null);
  const [menuAnexo, setMenuAnexo] = useState(null);
  const [aceitoDoAnexo, setAceitoDoAnexo] = useState("");








  const assinaturaAtual = () =>
    signMessage && user?.name ? `*${user.name}:*` : "";

  const abrirSeletorDeArquivo = (accept) => {
    setAceitoDoAnexo(accept || "");
    setMenuAnexo(null);




    setTimeout(() => inputArquivoRef.current?.click(), 0);
  };

  const gravadorRef = useRef(null);
  const streamRef = useRef(null);
  const pedacosRef = useRef([]);
  const formatoRef = useRef(null);




  useEffect(() => {
    return () => {
      try {
        if (gravadorRef.current && gravadorRef.current.state !== "inactive") {
          gravadorRef.current.stop();
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop());
        }
      } catch (e) {
        /* ignore */
      }
    };
  }, []);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditingMessageContext);

  const { adicionar, remover, marcarFalha } = useContext(
    MensagensPendentesContext
  );
  const { user } = useContext(AuthContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    if (editingMessage) {
      let text = editingMessage.body || "";
      // Strip any signature formatted as "*Name:*\n"
      const match = text.match(/^\*[^*]+:\*\n/);
      if (match) {
        text = text.slice(match[0].length);
      }
      setInputMessage(text);
      if (inputRef.current) inputRef.current.focus();
    }
  }, [editingMessage]);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    const draft = localStorage.getItem('draft_' + ticketId);
    if (draft) {
      setInputMessage(draft);
    } else {
      setInputMessage("");
    }
    return () => {
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);

  useEffect(() => {
    if (ticketId) {
      localStorage.setItem('draft_' + ticketId, inputMessage);
    }
  }, [inputMessage, ticketId]);

  const handleChangeInput = e => {
    setInputMessage(e.target.value);
    handleLoadQuickAnswer(e.target.value);
  };

  const handleQuickAnswersClick = value => {
    setInputMessage(value);
    setTypeBar(false);
  };

  // O atalho pode ser qualquer coisa: "/", "#bemvindo", "oi". Mostramos as
  // globais e as pessoais juntas — quando as duas usam o mesmo atalho, o
  // atendente escolhe qual quer na lista.
  const buscarAtalhos = async texto => {
    const termo = String(texto || "").trim();

    if (!termo || termo.length > 30 || /\s/.test(termo)) {
      setQuickAnswer([]);
      setTypeBar(false);
      return;
    }

    try {
      const { data } = await api.get("/quickAnswers/", {
        params: { searchParam: termo, pageNumber: 1 },
      });

      const encontrados = (data.quickAnswers || []).filter(q =>
        String(q.shortcut || "")
          .toLowerCase()
          .startsWith(termo.toLowerCase())
      );

      setQuickAnswer(encontrados);
      setTypeBar(encontrados.length > 0);
    } catch (err) {
      setQuickAnswer([]);
      setTypeBar(false);
    }
  };

  const handleAddEmoji = e => {
    let emoji = e.native;
    setInputMessage(prevState => prevState + emoji);
  };

  const handleChangeMedias = e => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
  };

  const handleInputPaste = e => {
    if (e.clipboardData.files[0]) {
      setMedias([e.clipboardData.files[0]]);
    }
  };

  const handleUploadMedia = async e => {
    setLoading(true);
    e.preventDefault();

    const legenda = inputMessage.trim();

    const corpo = [assinaturaAtual(), legenda].filter(Boolean).join("\n");

    const formData = new FormData();
    formData.append("fromMe", true);
      playSendMessageSound();
      medias.forEach(media => {
      formData.append("medias", media);
    });

    if (corpo) {
      formData.append("body", corpo);
    }

    try {
        playSendMessageSound();
        await api.post(`/messages/${ticketId}`, formData);
      setInputMessage("");
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;

    if (editingMessage) {
      try {
        let finalBody = inputMessage.trim();
        if (signMessage && user?.name) {
          finalBody = `*${user.name}:*\n${finalBody}`;
        }
        
        await api.put(`/messages/${editingMessage.id}`, {
          body: finalBody,
        });
      } catch (err) {
        toastError(err);
      }
      setInputMessage("");
      setShowEmoji(false);
      setEditingMessage(null);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: signMessage
        ? `*${user?.name}:*\n${inputMessage.trim()}`
        : inputMessage.trim(),
      quotedMsg: replyingMessage,
    };

    const tempId = `temp-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;



    
      adicionar({
        tempId,
      ticketId,
      body: message.body,
      quotedMsg: replyingMessage,
      criadoEm: Date.now(),
      payload: message,
    });

    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);

    try {
        playSendMessageSound();
        await api.post(`/messages/${ticketId}`, message);
      remover(tempId);
    } catch (err) {
      marcarFalha(tempId, err?.message);
      toastError(err);
    }
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        toast.error(
          "O navegador bloqueou o acesso ao microfone (requer HTTPS ou permissão nas configurações)."
        );
        setLoading(false);
        return;
      }

      const formato = formatoSuportado();
      if (!formato) {
        toast.error("Este navegador não suporta gravação de áudio.");
        setLoading(false);
        return;
      }

      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      } catch (e) {
        toast.error("Permissão do microfone negada ou dispositivo não encontrado.");
        setLoading(false);
        return;
      }

      const recorder = new MediaRecorder(
        stream,
        formato.mime ? { mimeType: formato.mime } : undefined
      );

      pedacosRef.current = [];
      recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) pedacosRef.current.push(e.data);
      };

      gravadorRef.current = recorder;
      streamRef.current = stream;
      formatoRef.current = formato;

      recorder.start();
      // O stream vai para o estado alem do ref: o ref sozinho nao provoca novo
      // render, e sem render as ondas nao teriam de onde ler o audio.
      setStreamDaGravacao(stream);
      setRecording(true);
      setLoading(false);
    } catch (err) {
      console.error("Erro ao gravar:", err);
      toast.error(
        "Não foi possível iniciar o microfone. Verifique suas permissões de áudio e segurança (HTTPS)."
      );
      setLoading(false);
    }
  };




  const encerrarGravacao = () =>
    new Promise((resolve) => {
      const recorder = gravadorRef.current;

      const desligarMicrofone = () => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((t) => t.stop());
          streamRef.current = null;
        }
        gravadorRef.current = null;
        setStreamDaGravacao(null);
      };

      if (!recorder || recorder.state === "inactive") {
        desligarMicrofone();
        resolve(null);
        return;
      }

      recorder.onstop = () => {
        const tipo =
          formatoRef.current?.mime?.split(";")[0] || "audio/webm";
        const blob = new Blob(pedacosRef.current, { type: tipo });
        pedacosRef.current = [];
        desligarMicrofone();
        resolve(blob);
      };

      recorder.stop();
    });

  const handleLoadQuickAnswer = value => {
    buscarAtalhos(value);
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const blob = await encerrarGravacao();

      if (!blob || blob.size < 1000) {
        toast.info("Áudio muito curto.");
        setLoading(false);
        setRecording(false);
        return;
      }

      const extensao = formatoRef.current?.extensao || "webm";











      const formData = new FormData();
      formData.append("medias", blob, `${new Date().getTime()}.${extensao}`);
      formData.append("fromMe", true);
        playSendMessageSound();

        playSendMessageSound();
        await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      await encerrarGravacao();
    } catch (err) {
      console.error("Erro ao cancelar o áudio:", err);
    }
    setRecording(false);
  };

  const handleOpenMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = event => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {formatarNomeOuTelefone(
                  message.contact?.name,
                  message.contact?.number
                )}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const renderEditingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span className={classes.replyginSelfMsgSideColor}></span>
          <div className={classes.replyginMsgBody}>
            <span className={classes.messageContactName}>
              Editando mensagem...
            </span>
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="cancelEdit"
          component="span"
          disabled={loading}
          onClick={() => {
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  // Atendimento sem conexao: a conexao dele foi excluida, caiu ou foi banida.
  // Nao adianta deixar digitar -- a mensagem morreria no envio e o atendente
  // ficaria achando que o cliente recebeu. Um administrador troca a conexao
  // pelo menu do atendimento e o campo volta.
  if (semConexao) {
    return (
      <Paper square elevation={0} className={classes.barraSemConexao}>
        <SignalWifiOffIcon className={classes.semConexaoIcone} />
        <div>
          <div className={classes.semConexaoTitulo}>SEM CONEXÃO</div>
          <div className={classes.semConexaoTexto}>
            {conexaoNome
              ? `Este cliente falava com a gente pela conexão “${conexaoNome}”, que não está mais no sistema. `
              : "A conexão deste atendimento não está mais no sistema. "}
            Não é possível enviar mensagens até escolher outra: abra o menu ⋮ aqui
            em cima e use "Trocar conexão".
          </div>
        </div>
      </Paper>
    );
  }

  // Conexao existe, mas nao esta conectada agora (caiu, foi desconectada ou
  // banida). Aqui NAO travamos o campo: quedas curtas se resolvem sozinhas e o
  // atendente nao pode ficar de maos atadas. So avisamos, porque o pior cenario
  // e ele escrever achando que o cliente recebeu.
  const conexaoOffline =
    !semConexao && !!conexaoStatus && conexaoStatus !== "CONNECTED";

  const avisoConexaoOffline = conexaoOffline ? (
    <div className={classes.faixaConexaoCaiu}>
      <SignalWifiOffIcon style={{ fontSize: 18, flexShrink: 0 }} />
      <span>
        O número{conexaoNome ? ` “${conexaoNome}”` : ""}, pelo qual você fala com
        este cliente, está desconectado. As mensagens podem não sair até ele
        voltar — dá para trocar a conexão pelo menu ⋮ aqui em cima.
      </span>
    </div>
  ) : null;

  if (medias.length > 0) {
    const arquivo = medias[0];
    const ehImagem = String(arquivo?.type || "").startsWith("image/");

    return (
      <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
        <IconButton
          aria-label="cancel-upload"
          component="span"
          onClick={e => {
            setMedias([]);
            setInputMessage("");
          }}
        >
          <CancelIcon className={classes.sendMessageIcons} />
        </IconButton>

        {loading ? (
          <div>
            <CircularProgress className={classes.circleLoading} />
          </div>
        ) : (
          <div className={classes.previaMidia}>
            {}
            {ehImagem ? (
              <img
                src={URL.createObjectURL(arquivo)}
                alt={arquivo?.name}
                className={classes.previaImagem}
              />
            ) : (
              <span className={classes.previaNome}>{arquivo?.name}</span>
            )}

            <div className={classes.previaLegenda}>
              <IconButton
                aria-label="emojiPicker"
                component="span"
                disabled={loading}
                onClick={e => setShowEmoji(prevState => !prevState)}
              >
                <MoodIcon className={classes.sendMessageIcons} />
              </IconButton>

              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={e => setShowEmoji(false)}>
                    <Picker
                      native
                      perLine={16}
                      showPreview={false}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                      color="#1E9855"
                      emojisToShowFilter={filtroDeEmoji}
                      exclude={["flags"]}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}

              <InputBase
                className={classes.campoLegenda}
                placeholder="Escreva uma legenda (opcional)"
                multiline
                maxRows={3}
                value={inputMessage}
                onChange={e => setInputMessage(e.target.value)}
                onKeyPress={e => {
                  if (loading) return;
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleUploadMedia(e);
                  }
                }}
              />
            </div>
          </div>
        )}
        <IconButton
          aria-label="send-upload"
          component="span"
          onClick={handleUploadMedia}
          disabled={loading}
        >
          <SendIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Paper>
    );
  }
  else {
    return (
      <Paper ref={raizRef} square elevation={0} className={clsx(classes.mainWrapper, compacto && classes.compacto)}>
        {avisoConexaoOffline}
        <ComunicadoDialog
          container={portalNaJanela}
          ticketId={ticketId}
          aberto={comunicadoAberto}
          onClose={() => setComunicadoAberto(false)}
        />
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        {editingMessage && renderEditingMessage(editingMessage)}
        <div className={classes.newMessageBox} ref={setCaixaEl}>
          <Hidden only={["sm", "xs"]}>
            <IconButton
              aria-label="emojiPicker"
              component="span"
              disabled={loading || recording}
              onClick={e => setShowEmoji(prevState => !prevState)}
            >
              <MoodIcon className={classes.sendMessageIcons} />
            </IconButton>
            <SeletorConteudo
              aberto={showEmoji}
              onFechar={() => setShowEmoji(false)}
              onEmoji={handleAddEmoji}
              ticketId={ticketId}
            />

            <input
              multiple
              type="file"
              ref={inputArquivoRef}
              disabled={loading || recording}
              className={classes.uploadInput}
              onChange={handleChangeMedias}
              accept={aceitoDoAnexo}
            />

            <IconButton
              aria-label="anexar"
              component="span"
              disabled={loading || recording}
              onClick={e => setMenuAnexo(e.currentTarget)}
            >
              <AddIcon className={classes.sendMessageIcons} />
            </IconButton>

            <Menu
              container={portalNaJanela}
              anchorEl={menuAnexo}
              open={Boolean(menuAnexo)}
              onClose={() => setMenuAnexo(null)}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "bottom", horizontal: "left" }}
              getContentAnchorEl={null}
            >
              {OPCOES_DE_ANEXO.map(opcao => (
                <MenuItem
                  key={opcao.id}
                  onClick={() => abrirSeletorDeArquivo(opcao.accept)}
                >
                  <ListItemIcon style={{ minWidth: 34, color: opcao.cor }}>
                    <opcao.Icone fontSize="small" />
                  </ListItemIcon>
                  {opcao.rotulo}
                </MenuItem>
              ))}
              <MenuItem
                onClick={() => {
                  setMenuAnexo(null);
                  setComunicadoAberto(true);
                }}
              >
                <ListItemIcon style={{ minWidth: 34, color: "#e91e8c" }}>
                  <AnnouncementIcon fontSize="small" />
                </ListItemIcon>
                Comunicado
              </MenuItem>
              <MenuItem
                disabled={enviandoSaudacao}
                onClick={() => {
                  setMenuAnexo(null);
                  enviarSaudacao();
                }}
              >
                <ListItemIcon style={{ minWidth: 34, color: "#16a34a" }}>
                  <EmojiPeopleIcon fontSize="small" />
                </ListItemIcon>
                Saudação
              </MenuItem>
              {!compacto && abrirCalculadora && (
                <MenuItem
                  onClick={() => {
                    setMenuAnexo(null);
                    abrirCalculadora(ticketId);
                  }}
                >
                  <ListItemIcon style={{ minWidth: 34, color: "#0ea5e9" }}>
                    <IconeCalculadora size={20} />
                  </ListItemIcon>
                  Amortização
                </MenuItem>
              )}
            </Menu>
            <FormControlLabel
              style={{ marginRight: 7, color: "gray" }}
              label={compacto || estreito ? "" : i18n.t("messagesInput.signMessage")}
              title={i18n.t("messagesInput.signMessage")}
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  checked={signMessage}
                  onChange={e => {
                    setSignMessage(e.target.checked);
                  }}
                  name="showAllTickets"
                  color="primary"
                />
              }
            />
          </Hidden>
          <Hidden only={["md", "lg", "xl"]}>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleOpenMenuClick}
            >
              <MoreVert></MoreVert>
            </IconButton>
            <Menu
              container={portalNaJanela}
              id="simple-menu"
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuItemClick}
            >
              <MenuItem onClick={handleMenuItemClick}>
                <IconButton
                  aria-label="emojiPicker"
                  component="span"
                  disabled={loading || recording}
                  onClick={e => setShowEmoji(prevState => !prevState)}
                >
                  <MoodIcon className={classes.sendMessageIcons} />
                </IconButton>
              </MenuItem>
              {OPCOES_DE_ANEXO.map(opcao => (
                <MenuItem
                  key={opcao.id}
                  disabled={loading || recording}
                  onClick={() => {
                    handleMenuItemClick();
                    abrirSeletorDeArquivo(opcao.accept);
                  }}
                >
                  <ListItemIcon style={{ minWidth: 34, color: opcao.cor }}>
                    <opcao.Icone fontSize="small" />
                  </ListItemIcon>
                  {opcao.rotulo}
                </MenuItem>
              ))}
              <MenuItem
                disabled={enviandoSaudacao}
                onClick={() => {
                  handleMenuItemClick();
                  enviarSaudacao();
                }}
              >
                <ListItemIcon style={{ minWidth: 34, color: "#16a34a" }}>
                  <EmojiPeopleIcon fontSize="small" />
                </ListItemIcon>
                Saudação
              </MenuItem>
              <MenuItem onClick={handleMenuItemClick}>
                <FormControlLabel
                  style={{ marginRight: 7, color: "gray" }}
                  label={i18n.t("messagesInput.signMessage")}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={signMessage}
                      onChange={e => {
                        setSignMessage(e.target.checked);
                      }}
                      name="showAllTickets"
                      color="primary"
                    />
                  }
                />
              </MenuItem>
            </Menu>
          </Hidden>
          <div className={classes.messageInputWrapper}>
            <InputBase
              inputRef={input => {
                // Volta o cursor para a mensagem a cada atualização, MAS nunca
                // tira o foco de outro campo que o atendente esteja usando
                // (calculadora, janelinha de conversa, busca...). Antes, cada
                // tecla digitada na calculadora jogava o cursor para cá.
                if (input && !compacto) {
                  const ativo = document.activeElement;
                  const usandoOutroCampo =
                    ativo &&
                    ativo !== input &&
                    ativo.matches &&
                    ativo.matches('input, textarea, select, [contenteditable="true"]');
                  if (!usandoOutroCampo) input.focus();
                }
                input && (inputRef.current = input);
              }}
              className={classes.messageInput}
              placeholder={
                estreito || compacto
                  ? "Digite uma mensagem"
                  : ticketStatus === "open"
                  ? i18n.t("messagesInput.placeholderOpen")
                  : poderDeAdmin(user?.profile)
                  ? "Responda aqui para assumir este atendimento..."
                  : i18n.t("messagesInput.placeholderClosed")
              }
              multiline
              maxRows={5}
              value={inputMessage}
              onChange={handleChangeInput}
              disabled={recording || loading}
              onPaste={e => {
                handleInputPaste(e);
              }}
              onKeyPress={e => {
                if (loading || e.shiftKey) return;
                else if (e.key === "Enter") {
                  handleSendMessage();
                }
              }}
            />
            {typeBar ? (
              <ul className={classes.messageQuickAnswersWrapper}>
                {quickAnswers.map((value, index) => {
                  const ehMinha = !!value.userId;
                  return (
                    <li
                      className={classes.messageQuickAnswersWrapperItem}
                      key={value.id || index}
                    >
                      {}
                      <a onClick={() => handleQuickAnswersClick(value.message)}>
                        <span className={classes.atalhoTag}>
                          {value.shortcut}
                        </span>
                        <span
                          className={
                            ehMinha
                              ? classes.escopoTagPessoal
                              : classes.escopoTagGlobal
                          }
                        >
                          {ehMinha
                            ? +value.userId === +user?.id
                              ? "minha"
                              : value.user?.name || "pessoal"
                            : "global"}
                        </span>
                        <span className={classes.atalhoTexto}>
                          {value.message}
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div></div>
            )}
          </div>
          {/*
            Microfone quando o campo esta vazio, enviar quando tem texto — como
            no WhatsApp. O trim() importa: com um espaco solto no campo, o botao
            virava "enviar" e o microfone sumia, mas o envio nem funcionava
            (handleSendMessage descarta mensagem so com espaco). Ficava um botao
            morto no lugar do microfone.
          */}
          {inputMessage.trim() ? (
            <IconButton
              aria-label="sendMessage"
              component="span"
              onClick={handleSendMessage}
              disabled={loading}
            >
              <SendIcon className={classes.sendMessageIcons} />
            </IconButton>
          ) : recording ? (
            <div className={classes.recorderWrapper}>
              <Tooltip title="Descartar gravação">
                <IconButton
                  aria-label="cancelRecording"
                  component="span"
                  className={classes.botaoDescartar}
                  disabled={loading}
                  onClick={handleCancelAudio}
                >
                  <DeleteOutlineIcon className={classes.cancelAudioIcon} />
                </IconButton>
              </Tooltip>
              {loading ? (
                <div>
                  <CircularProgress className={classes.audioLoading} />
                </div>
              ) : (
                <>
                  <OndasDaGravacao stream={streamDaGravacao} />
                  <RecordingTimer />
                </>
              )}

              <Tooltip title="Enviar áudio">
                <IconButton
                  aria-label="sendRecordedAudio"
                  component="span"
                  className={classes.botaoEnviarAudio}
                  onClick={handleUploadAudio}
                  disabled={loading}
                >
                  <SendIcon className={classes.sendAudioIcon} />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            <IconButton
              aria-label="showRecorder"
              component="span"
              disabled={loading}
              onClick={handleStartRecording}
            >
              <MicIcon className={classes.sendMessageIcons} />
            </IconButton>
          )}
        </div>
      </Paper>
    );
  }
};

export default MessageInput;












